import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class ShowerWallAccent extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = "shower_wall_accent";
    this.partName = "Shower Walls Accent";
    this.translateId = "visualizer.bathroom.shower.shower_wall_accent";
    this.dbName = "Shower Wall Accent";
    this.homePageTitle = 'Interior Shower Walls';
    this.isStoneFeature = true;
    this.canUseWizard = true;
    this.layerPriority = 2;
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    super.handleClick(ignoreLocked);
    const shower = parent.getParent();
    if (shower.showerWallAccent && shower.showerWallAccent.canBeDisabled
      && !shower.showerWallAccent.placeholderChanged && !getFeatureIsLocked(this)) {
      shower.showerWallAccent.disabled = true;
      shower.showerWallAccent.disabledClick();
    }
    this.featureClicked();
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }
}
